import { render, staticRenderFns } from "./AdminMobile.vue?vue&type=template&id=7b37ae41&scoped=true&"
import script from "./AdminMobile.vue?vue&type=script&lang=ts&"
export * from "./AdminMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b37ae41",
  null
  
)

export default component.exports